import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {DOCUMENT, NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {Config} from "../../../config/config";

@Component({
    selector: 'db-trustpilot',
    templateUrl: './trustpilot.component.html',
    styleUrls: ['./trustpilot.component.scss'],
    imports: [
        NgClass,
        NgIf,
        NgTemplateOutlet
    ]
})
export class TrustPilotComponent implements OnInit, AfterViewInit {
  protected readonly Config = Config;
  @Input() version: string = 'micro-star';
  @Input() class?: string;
  @Input() showNumber?: boolean = false;
  @Input() showServices?: boolean;
  @Input() isDark?: boolean = false;

  @ViewChild('trustbox', {read: ElementRef, static: false}) trustbox!: ElementRef;
  @ViewChild('microStar', {static: true}) microStar!: TemplateRef<any>;
  @ViewChild('microCombo', {static: true}) microCombo!: TemplateRef<any>;

  selectedVersion!: TemplateRef<any>;

  private scriptLoaded = false; // Track script loading status

  constructor(
    private _renderer2: Renderer2,
    private _cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  ngOnInit() {
    this._setVersion(); // Set the template version early
    this.loadTrustpilotScript(); // Ensure script is loaded as soon as possible
  }

  ngAfterViewInit() {
    this._cdr.detectChanges();
    this.initializeTrustbox();
  }

  private loadTrustpilotScript() {
    if (!this.scriptLoaded && !this._document.getElementById("trustpilot-script")) {
      const script = this._renderer2.createElement('script');
      script.type = `text/javascript`;
      script.id = `trustpilot-script`;
      script.async = true;
      script.src = `https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js`;
      script.onload = () => {
        this.scriptLoaded = true;
        this.initializeTrustbox();
      };
      this._renderer2.appendChild(this._document.body, script);
    } else if (this.scriptLoaded) {
      this.initializeTrustbox(); // Script already loaded, initialize directly
    }
  }

  private initializeTrustbox() {
    if (!this.trustbox) {
      return;
    }
    if (this.trustbox?.nativeElement) {
      // Set the data-theme attribute
      this.trustbox.nativeElement.setAttribute(
        'data-theme',
        this.isDark ? 'dark' : 'light'
      );

      // Ensure the Trustpilot script is loaded
      if (this.scriptLoaded) {
        // Reinitialize Trustpilot widget
        setTimeout(() => {
          // @ts-ignore
          window.Trustpilot?.loadFromElement(this.trustbox.nativeElement);
        }, 0);
      }
      // @ts-ignore
      window.Trustpilot?.loadFromElement(this.trustbox.nativeElement);
    }
  }


  private _setVersion() {
    this.selectedVersion = this.version === 'micro-combo' ? this.microCombo : this.microStar;
  }
}
